import React, { useEffect, useState } from "react";
import { getWalletByCustomerId } from "../../../services/Wallet/Wallet";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaWallet } from "react-icons/fa";
import AddWallet from "./AddWallet";

export default function Wallet() {
  const storedUser = localStorage.getItem("medarphaUser");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const customerId = Number(
    user?.id ?? user?.userId ?? user?.UserId ?? user?.UserID ?? 0
  );

  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showAddWallet, setShowAddWallet] = useState(false);

  // ✅ Fetch wallet function (can be called anytime to refresh data)
  const fetchWalletData = async () => {
    if (!customerId || Number.isNaN(customerId)) {
      setError("No customer found. Please log in again.");
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const data = await getWalletByCustomerId(customerId);
      if (data) {
        setWallet(data);
        setError("");
      } else {
        setWallet(null);
        setError("No wallet data found.");
      }
    } catch (err) {
      console.error("Wallet Fetch Error:", err);
      setError("Failed to fetch wallet data.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Initial fetch
  useEffect(() => {
    fetchWalletData();
  }, [customerId]);

  if (loading) {
    return <p className="text-center mt-4 text-muted">Loading wallet...</p>;
  }

  if (error) {
    return <p className="text-center mt-4 text-danger">{error}</p>;
  }

  if (!wallet) {
    return <p className="text-center mt-4 text-muted">Wallet not available.</p>;
  }

  // ➕ Add Wallet Page
  if (showAddWallet) {
    return (
      <AddWallet
        wallet={wallet}
        customerId={customerId}
        // 🔄 onBack triggers wallet refresh
        onBack={() => {
          setShowAddWallet(false);
          fetchWalletData(); // refresh wallet after closing AddWallet
        }}
      />
    );
  }

  return (
    <div className="container mt-4">
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="fw-bold text-danger d-flex align-items-center gap-2">
          <FaWallet size={22} /> My Wallet
        </h4>
        <span className="badge bg-light text-danger p-2 px-3 shadow-sm">
          Customer ID: {wallet.customerId}
        </span>
      </div>

      {/* Balance Card */}
      <div
        className="card border-0 shadow-lg p-4 mb-4 text-center"
        style={{
          borderRadius: "16px",
          background:
            "linear-gradient(135deg, #ffb3b3, #ffcccc, #ffe6e6, #ffffff)",
        }}
      >
        <FaWallet size={50} className="text-danger mb-3" />

        <h5 className="fw-bold mb-2 text-secondary">Available Balance</h5>

        <p className="fw-bolder fs-2 text-danger">
          ₹{Number(wallet.currentBalance).toLocaleString("en-IN")}
        </p>

        <button
          className="btn btn-danger rounded-pill px-4 fw-semibold mt-2 shadow-sm"
          onClick={() => setShowAddWallet(true)}
        >
          + Add to Wallet
        </button>
      </div>
    </div>
  );
}
